




import {Component, Ref, Vue} from 'vue-property-decorator'
import TariffZone from '../Tarification/TariffZone.vue';
import {TarificationTypes, TarificationTransports} from "@/store/tarification/types";

Component.registerHooks([
  'beforeRouteLeave',
])
@Component({components: {TariffZone}})
export default class CallOperatorTariffZone extends Vue{
  @Ref('tariffZone') tariffZone: any;
  private operatorType: TarificationTypes = TarificationTypes.OPERATOR
  private tarificationTransport: TarificationTransports = TarificationTransports.CALL

  beforeRouteLeave(to:any, from:any, next:any) {
    this.tariffZone.beforeLeave(to,from,next)
  }
}
